import { TheftInsuranceQuotation } from "./components";

export const StepThree = () => <TheftInsuranceQuotation />;